export const bookingDataParams = [
  // data related params
  'appointment_id',
  'appointment_types',
  'lab_id',
  'clinic_id',
  'time_slot_id',
  'partner_clinic_search',
  'confirmed_appointment_id',
  'provider_id',
  'date'
] as const;

export const bookingFormParams = [
  // booking multi step form params
  'target',
  'step'
] as const;

export const bookingParams = [...bookingDataParams, ...bookingFormParams] as const;
